import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import kubernetesPlugin from '@backstage/plugin-kubernetes/alpha';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
import githubActionsPlugin from '@backstage-community/plugin-github-actions/alpha';
import githubInsightsPlugin from '@roadiehq/backstage-plugin-github-insights/alpha';
import { navModule } from './modules/nav';
import { themesModule } from './modules/themes';
import { authModule } from './modules/auth';
// ECR plugin DESABILITADO mesmo com patch-package aplicado:
// 1. Patch (patches/@aws+amazon-ecr-plugin-for-backstage+0.2.2.patch) adiciona
//    `routes: { root: rootRouteRef }` ao createPlugin upstream — routes
//    REGISTRAM (erro mudou de id=amazon-ecr pra id=amazon-ecr.root,legacyId=amazon-ecr).
// 2. PORÉM o componente `EntityAmazonEcrImagesContent` eh routable extension
//    (mountPoint=rootRouteRef) que NFS so monta via PageBlueprint absoluto.
//    EntityContentBlueprint (tab) nao satisfaz "discovered in app element tree".
//    PageBlueprint absoluto tampouco funciona porque componente chama useEntity()
//    e precisa de contexto entity-scoped.
// 3. Resolucao real exige FORK do plugin pra reescrever em NFS nativo
//    OU aguardar AWS Labs publicar /alpha entrypoint.
// Patch + module + deps + backend ficam no codigo pra rapida reativacao quando
// upstream resolver. Annotations aws.amazon.com/amazon-ecr-arn nos catalog-info
// ficam inertes ate la (zero impacto, sao apenas metadata).
// import { ecrPlugin } from './modules/ecr';

export default createApp({
  features: [
    catalogPlugin,
    apiDocsPlugin,
    kubernetesPlugin,
    techdocsPlugin,
    githubActionsPlugin,
    githubInsightsPlugin,
    navModule,
    themesModule,
    authModule,
    // ecrPlugin, // ver comentario no import
  ],
});
